class Pagination {
    constructor() {
        this.$ = jQuery;
    }

    initPagination() {
        $(document).on("click", "ul.pagination .page-numbers", function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $pageNum = $(this);

            if ($pageNum.hasClass("current") || $pageNum.hasClass("dots")) {
                return;
            }

            var href = $pageNum.attr("href");
            if (!href) return;

            // Preserve filter parameter if present in current URL but missing from link
            const currentParams = new URLSearchParams(window.location.search);
            const filterParam = currentParams.get("filter");
            if (filterParam) {
                const url = new URL(href, window.location.origin);
                if (!url.searchParams.get("filter")) {
                    url.searchParams.set("filter", filterParam);
                }
                href = url.toString();
            }

            window.location.href = href;
        });
    }
}

export default Pagination;
